export default __webpack_public_path__ + "static/consultant-three-5918515a36f71e3cf3e19795dcaeb6e1.png";